let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1y1eN")).then(() => parcelRequire('k5E3d'));